// Absolute URL Stripe redirects to after confirmPayment / confirmSetup.
//
// Two things have to be right at once:
//   1. The path — every charge type has its own confirmation page/copy
//      (see RETURN_PATHS). A forgotten returnPath used to dump membership
//      payers back onto the enroll form (`/membership2026`) with no
//      thank-you at all.
//   2. The origin — Stripe needs an absolute URL. Production sets
//      REACT_APP_URL (https://kbtla.org, no trailing slash).
//      If that env is missing we fall back to window.location.origin so
//      the redirect still lands on THIS site instead of
//      `undefined/payment-success`.
export const RETURN_PATHS = {
  membership: '/membership2026/thank-you',
  guestSeats: '/membership2026/thank-you?context=guest-seats',
  extraSeats: '/membership2026/thank-you?context=extra-seats',
  donation: '/payment-success',
  invoice: '/payment-success?context=invoice',
  paymentPlan: '/payment-success?context=plan',
  // Pay-link payers (invoice email, no login) get their own context so the
  // thank-you page never offers "Back to My Account" — there is no account.
  payLink: '/payment-success?context=paylink',
  payLinkPlan: '/payment-success?context=paylink-plan',
};

export const checkoutReturnUrl = (returnPath = RETURN_PATHS.donation) => {
  const envBase = process.env.REACT_APP_URL;
  const origin =
    typeof window !== 'undefined' && window.location && window.location.origin
      ? window.location.origin
      : '';
  const base = String(envBase || origin).replace(/\/$/, '');
  const path = returnPath.startsWith('/') ? returnPath : `/${returnPath}`;
  return `${base}${path}`;
};
